import config from "../../../config";
import Storage from "../../../helpers/Storage";
import Roles from "../../constants/Roles";
import BaseApi from "../BaseApi";

const baseApi = new BaseApi();

export default class User {
  Entity = "user";

  userLogUpdate = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "logUpdate";
    const processedData = {
      id: data?.userLogID,
      succeeded: true
    };

    return baseApi.customCreate(processedData, {entity: this.Entity, action: action});
  }

  getUserSignature = (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "getSignature";

    let url = baseApi.customJustReturnURL({entity: this.Entity, action: action});

    return `${config.baseUrl}${url}?id=${data.userID}&etag=${data.eTag}`;
  }

  userLogCreate = async (data = null) => {
    if (!data) {
      throw new Error("Data is null...!!!");
    }

    const action = "logCreate";
    const processedData = {
      action: data?.action,
      study_id: data?.studyID,
      path: data?.path,
    };

    return baseApi.customCreate(processedData, {entity: this.Entity, action: action});
  }

  #checkRole = (role, includeAdmin) => {
    let roles = parseInt(Storage.getRoles());
    let result = (roles & role) === role;

    if (result && !includeAdmin && role === Roles.ROLE_ADMIN) {
      result = false;
    }

    return result;
  }

  #checkHasAnyRole = (roles) => {
    for (let role of roles) {
      if (this.#checkRole(role)) {
        return true;
      }
    }

    return false;
  }

  isGuest = () => {
    let res = Storage.getRoles() ;
    console.log(res)
    return ( res );
  }

  isAdmin = () => {
    return this.#checkRole(Roles.ROLE_ADMIN);
  }

  isTypist = () => {
    return this.#checkRole(Roles.ROLE_TYPIST);
  }

  isStaff = () => {
    return this.#checkRole(Roles.ROLE_STAFF);
  }

  isResident = () => {
    return this.#checkRole(Roles.ROLE_RESIDENT);
  }

  isAssistant = () => {
    return this.#checkRole(Roles.ROLE_ASSISTANT);
  }

  isAccount = () => {
    return this.#checkRole(Roles.ROLE_ACCOUNT);
  }

  isDepartmentMaster = () => {
    return this.#checkRole(Roles.ROLE_DEPARTMENT_MASTER);
  }

  canAccessSignature = () => {
    return this.#checkHasAnyRole([Roles.ROLE_ASSISTANT, Roles.ROLE_STAFF]);
  }

  canAccessSettingPermissionsSection = () => {
    return this.#checkHasAnyRole([Roles.ROLE_STAFF]);
  }

  canAccessAddPatient = () => {
    return this.#checkHasAnyRole([Roles.ROLE_STAFF, Roles.ROLE_RESIDENT, Roles.ROLE_TYPIST]);
  }
}
